import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { forwardRef, useState } from 'react';
import { Textarea as Textarea$1 } from '@bucketplace/commerce-admin-ui';
import { ODS_FONT_STYLE } from '@bucketplace/design-system';
import { jsx } from '@emotion/react';

var MAX_ROWS = 3;
var URLInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    _onChange = _ref.onChange,
    _onBlur = _ref.onBlur;
  var _useState = useState(MAX_ROWS),
    _useState2 = _slicedToArray(_useState, 2),
    maxRows = _useState2[0],
    setMaxRows = _useState2[1];
  return jsx(Textarea, {
    ref: ref,
    value: value !== null && value !== void 0 ? value : '',
    maxRows: readOnly ? MAX_ROWS : maxRows,
    autoHeight: true,
    readOnly: readOnly,
    placeholder: placeholder,
    onFocus: function onFocus() {
      return setMaxRows(undefined);
    },
    onChange: function onChange(event) {
      var value = event.target.value.replace(/\s/g, '');
      _onChange === null || _onChange === void 0 || _onChange(value);
    },
    onBlur: function onBlur() {
      setMaxRows(MAX_ROWS);
      _onBlur === null || _onBlur === void 0 || _onBlur();
    }
  });
});
var Textarea = /*#__PURE__*/_styled(Textarea$1, process.env.NODE_ENV === "production" ? {
  target: "ekp8emq0"
} : {
  target: "ekp8emq0",
  label: "Textarea"
})("padding-top:0;padding-bottom:0;>textarea{", ODS_FONT_STYLE.body14L20, ";", function (_ref2) {
  var maxRows = _ref2.maxRows;
  return !!maxRows && "\n      max-height: ".concat(maxRows * 20, "px;\n    ");
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVSTElucHV0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2Q3dEIiwiZmlsZSI6IlVSTElucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDaGFuZ2VFdmVudCwgZm9yd2FyZFJlZiwgUmVhY3RFbGVtZW50LCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRleHRhcmVhIGFzIF9UZXh0YXJlYSB9IGZyb20gJ0BidWNrZXRwbGFjZS9jb21tZXJjZS1hZG1pbi11aSc7XG5pbXBvcnQgeyBPRFNfRk9OVF9TVFlMRSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuY29uc3QgTUFYX1JPV1MgPSAzO1xuXG5pbnRlcmZhY2UgVVJMSW5wdXRQcm9wcyB7XG4gIHZhbHVlOiBzdHJpbmc7XG4gIHBsYWNlaG9sZGVyPzogc3RyaW5nO1xuICByZWFkT25seT86IGJvb2xlYW47XG4gIG9uQ2hhbmdlPzogKHZhbHVlOiBzdHJpbmcpID0+IHZvaWQ7XG4gIG9uQmx1cj86ICgpID0+IHZvaWQ7XG59XG5cbmV4cG9ydCBjb25zdCBVUkxJbnB1dCA9IGZvcndhcmRSZWY8SFRNTFRleHRBcmVhRWxlbWVudCwgVVJMSW5wdXRQcm9wcz4oKHtcbiAgdmFsdWUsXG4gIHBsYWNlaG9sZGVyLFxuICByZWFkT25seSxcbiAgb25DaGFuZ2UsXG4gIG9uQmx1cixcbn0sIHJlZik6IFJlYWN0RWxlbWVudCA9PiB7XG4gIGNvbnN0IFttYXhSb3dzLCBzZXRNYXhSb3dzXSA9IHVzZVN0YXRlPG51bWJlciB8IHVuZGVmaW5lZD4oTUFYX1JPV1MpO1xuXG4gIHJldHVybiAoXG4gICAgPFRleHRhcmVhXG4gICAgICByZWY9e3JlZn1cbiAgICAgIHZhbHVlPXt2YWx1ZSA/PyAnJ31cbiAgICAgIG1heFJvd3M9e3JlYWRPbmx5ID8gTUFYX1JPV1MgOiBtYXhSb3dzfVxuICAgICAgYXV0b0hlaWdodFxuICAgICAgcmVhZE9ubHk9e3JlYWRPbmx5fVxuICAgICAgcGxhY2Vob2xkZXI9e3BsYWNlaG9sZGVyfVxuICAgICAgb25Gb2N1cz17KCkgPT4gc2V0TWF4Um93cyh1bmRlZmluZWQpfVxuICAgICAgb25DaGFuZ2U9eyhldmVudCkgPT4ge1xuICAgICAgICBjb25zdCB2YWx1ZSA9IChldmVudCBhcyB1bmtub3duIGFzIENoYW5nZUV2ZW50PEhUTUxUZXh0QXJlYUVsZW1lbnQ+KS50YXJnZXQudmFsdWUucmVwbGFjZSgvXFxzL2csICcnKTtcbiAgICAgICAgb25DaGFuZ2U/Lih2YWx1ZSk7XG4gICAgICB9fVxuICAgICAgb25CbHVyPXsoKSA9PiB7XG4gICAgICAgIHNldE1heFJvd3MoTUFYX1JPV1MpO1xuICAgICAgICBvbkJsdXI/LigpO1xuICAgICAgfX1cbiAgICAvPlxuICApO1xufSk7XG5cbmNvbnN0IFRleHRhcmVhID0gc3R5bGVkKF9UZXh0YXJlYSk8eyBtYXhSb3dzPzogbnVtYmVyIH0+YFxuICBwYWRkaW5nLXRvcDogMDtcbiAgcGFkZGluZy1ib3R0b206IDA7XG5cbiAgPiB0ZXh0YXJlYSB7XG4gICAgJHtPRFNfRk9OVF9TVFlMRS5ib2R5MTRMMjB9O1xuICAgICR7KHsgbWF4Um93cyB9KSA9PiAhIW1heFJvd3MgJiYgYFxuICAgICAgbWF4LWhlaWdodDogJHttYXhSb3dzICogMjB9cHg7XG4gICAgYH1cbiAgfVxuYDtcbiJdfQ== */"));

export { URLInput };
//# sourceMappingURL=URLInput.js.map
